import { Module } from 'vuex';
import { RootState } from 'frontend/types';

export interface AppDownloadLinksState {
  android: string;
  ios: string;
}

export const appDownloadLinks: Module<AppDownloadLinksState, RootState> = {
  namespaced: true,
  state: {
    ios: 'https://apps.apple.com/app/apple-store/id913335252?pt=105095803&ct=nux_qr_code&mt=8',
    android:
      'https://play.google.com/store/apps/details?id=org.brilliant.android&listing=try-brilliant-app',
  },
  mutations: {
    setValue(state: AppDownloadLinksState, value: AppDownloadLinksState): void {
      Object.assign(state, value);
    },
  },
};

interface AppInstallationStatus {
  value: boolean;
}

export const appInstallationStatus: Module<AppInstallationStatus, RootState> = {
  namespaced: true,
  state: {
    value: false,
  },
  getters: {
    appInstalled: (state: AppInstallationStatus): boolean => state.value,
  },
  mutations: {
    setValue(state: AppInstallationStatus, value: AppInstallationStatus): void {
      Object.assign(state, value);
    },
  },
};
